import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { I18n } from 'components';
import { formatLogin } from 'utils/formatString';

import FieldSwitcher from '../FieldSwitcher';
import styles from './styles.pcss';
import { PHONE_NUMBER_PLACEHOLDER } from '../constants';

const cx = classNames.bind(styles);

const FormGroupField = ({
  label, error, ctn, fieldId, errorVars, ...props
}) => (
  <div className={cx('container')} {...fieldId && { id: fieldId }}>
    <div className={cx('label')}>
      {label.replace(PHONE_NUMBER_PLACEHOLDER, formatLogin(ctn))}
    </div>
    <div className={cx('input', { fail: !!error })}>
      <FieldSwitcher {...props} />
      {error
      && (
        <div className={cx('error')}>
          <I18n path={error} vars={errorVars} />
        </div>
      )}
    </div>
  </div>
);

FormGroupField.propTypes = {
  fieldId: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  ctn: PropTypes.string,

  errorVars: PropTypes.object,
};

export default FormGroupField;
